export const formatNumber = number => new Intl.NumberFormat('da-DK').format(number);